import React from 'react';
import ExamQuestion from './ExamQuestion';

const ExamGapArticle = ({ task, answers, submitted, resultDetails, onAnswer }) => {
  const bank = task.sentenceBank || [];
  const paragraphs = task.article?.paragraphs || [];

  return (
    <div className="mb-4">
      <div className="exam-text-block">
        <div className="p-3 border-b border-gray-300">
          <strong>{task.article?.title}</strong>
          {task.article?.subtitle && (
            <p className="italic text-sm mt-1">{task.article.subtitle}</p>
          )}
        </div>
        <div className="exam-text-block-body">
          {paragraphs.map((para, pi) => (
            <p key={pi} className="mb-3">
              {para.split(/(\{\{GAP:\d+\}\})/).map((part, i) => {
                const match = part.match(/\{\{GAP:(\d+)\}\}/);
                if (!match) return part;
                const gapNum = match[1];
                const q = task.questions?.find((item) => String(item.gap) === gapNum);
                const qId = q?.id;
                const selected = answers[qId];
                const ok = resultDetails[qId]?.is_correct;
                const wrong = submitted && selected && !ok;
                return (
                  <span key={i} className="inline-block mx-0.5">
                    <select
                      disabled={submitted}
                      value={selected || ''}
                      onChange={(e) => onAnswer(qId, e.target.value)}
                      className={`exam-gap-select ${submitted && ok ? 'bg-green-100 border-green-700' : ''} ${wrong ? 'bg-red-100 border-red-700' : ''}`}
                    >
                      <option value="">[{gapNum}]</option>
                      {bank.map((s) => (
                        <option key={s.id} value={s.id}>{s.id}</option>
                      ))}
                    </select>
                  </span>
                );
              })}
            </p>
          ))}
        </div>
      </div>
      <div className="exam-sentence-bank">
        <p className="exam-sentence-bank-title">Beispiel / Sätze</p>
        <ul className="space-y-1.5">
          {bank.map((s) => (
            <li key={s.id}>
              <strong>{s.id}</strong> {s.text}
            </li>
          ))}
        </ul>
      </div>
      {submitted && task.questions?.map((q, i) => {
        const d = resultDetails[q.id];
        if (d?.is_correct) return null;
        return (
          <p key={q.id} className="text-[11px] mt-2 text-red-800 font-sans">
            Lücke {q.gap}: Ihre Antwort <strong>{(answers[q.id] || '—').toUpperCase()}</strong>
            {' · '}Richtig <strong>{(d?.correct_answer || '').toUpperCase()}</strong>
          </p>
        );
      })}
    </div>
  );
};

const ExamLesenContent = ({ task, answers, submitted, resultDetails, onAnswer, questionStartIndex }) => {
  let qNum = questionStartIndex;

  return (
    <div className="exam-teil-block">
      <h2 className="exam-teil-heading">Teil {task.teil}</h2>
      {task.arbeitzeit && <p className="text-sm font-bold mb-2">{task.arbeitzeit}</p>}
      <p className="exam-instruction">{task.instruction}</p>

      {task.id === 'lesen-teil2' && (
        <ExamGapArticle
          task={task}
          answers={answers}
          submitted={submitted}
          resultDetails={resultDetails}
          onAnswer={onAnswer}
        />
      )}

      {task.headlines?.length > 0 && (
        <div className="border border-gray-400 p-3 mb-4 text-sm">
          <p className="font-bold text-xs uppercase tracking-wide mb-2">Überschriften</p>
          <ol className="list-decimal list-inside space-y-1">
            {task.headlines.map((h) => (
              <li key={h.id}>{h.text}</li>
            ))}
          </ol>
        </div>
      )}

      {task.headings?.length > 0 && (
        <div className="border border-gray-400 p-3 mb-4 text-sm">
          <p className="font-bold text-xs uppercase tracking-wide mb-2">Inhaltsverzeichnis</p>
          <ul className="space-y-0.5">
            {task.headings.map((h) => (
              <li key={h.id}><strong>{h.label}</strong> {h.text}</li>
            ))}
          </ul>
        </div>
      )}

      {task.texts?.map((text) => (
        <div key={text.id} className="exam-text-block">
          {text.label && <span className="exam-text-block-label">{text.label}</span>}
          {text.author && <p className="exam-text-block-author">{text.author}</p>}
          <p className="exam-text-block-body whitespace-pre-line">{text.body}</p>
        </div>
      ))}

      {task.id !== 'lesen-teil2' && (
        <div className="mt-4 border-t border-gray-400 pt-3">
          {task.questions?.map((q) => {
            qNum += 1;
            return (
              <ExamQuestion
                key={q.id}
                question={q}
                task={task}
                index={qNum}
                answers={answers}
                submitted={submitted}
                resultDetails={resultDetails}
                onAnswer={onAnswer}
              />
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ExamLesenContent;
